import React from 'react';
import Footer from "./modules/views/Footer";
import AppAppBar from "./modules/views/AppAppBar";
import RoutesMap3D from "./modules/views/RoutesMap3D";

function RoutesPage() {
  return (
    <React.Fragment>
      <AppAppBar />
      <RoutesMap3D />
      <Footer />
    </React.Fragment>
  );
}

export default RoutesPage;
